import React from "react";
import styled from "styled-components";
import BooKImage from "./Navbar";
import Button from "../../../components/Button";
import theme from "../../../styles/colors";
import { Headline, Title1, Caption1 } from "../../../styles/typography";
import { TbArrowLeft } from "react-icons/tb";
import { EVENTS, track } from "../../../util/analytics";
const ThankYouContainer = styled.div`
  height: 100vh;
  width: 100%;
  overflow: hidden;
  transition: 0.7s;
`;

const ThankYouBookCard = styled.div`
  width: 100%;
  max-width: 800px;
  margin: auto;
  padding: 24px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const CardHeader = styled.div`
  margin: ${(props) => props.margin};
  @media screen and (max-width: 599px) {
    text-align: start;
  }
`;

const CardTitle = styled(Title1)`
  color: ${theme.buttonPrimaryBg};
  font-size: 30px;
  line-height: 125%;
`;

const CardDescription = styled(Headline)`
  color: ${`rgb(${theme.colors.neutral400})`};
`;

const TyCardDescription = styled.div`
  width: auto;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 19px;
  line-height: 23px;
  display: flex;
  align-items: center;
  margin-top: 20px;
  color: ${`rgb(${theme.colors.neutral400})`};
  display: inline-block;
`;

const TyCardFooter = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  @media screen and (max-width: 599px) {
    flex-direction: column;
    align-items: center;
  }
`;

const TyCardButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  background: #f3f5f7;
  border: 2px solid #e2e4e9;
  border-radius: 1000px;
  @media screen and (max-width: 600px) {
    margin-right: auto;
  }
`;

const TyContainer = styled.div`
  margin-top: 114px;
`;

const TyFooter = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0%;
  width: 100%;
  margin-bottom: 24px;
`;

const TyFooterText = styled(Caption1)`
  color: #4c5367;
  display: flex;
  gap: 4px;
`;

const TyFooterLink = styled.span`
  color: #4c5367;
`;

const SectionHeading = styled(Headline)`
  color: ${`rgb(${theme.colors.neutral400})`};
  font-weight: 700;
  margin-top: 20px;
`;

const FormLink = styled.div`
  font-family: "Inter";
  font-weight: 400;
  font-size: 19px;
  line-height: 23px;
  text-decoration: none;
  cursor: pointer;
  color: rgb(${(props) => props.theme.colors.accent400});
  @media (hover: hover) {
    :hover {
      text-decoration: underline !important;
    }
  }
`;

const ThankYouComponent = ({ closeWindow }, ref) => {
  React.useEffect(() => {
    track(EVENTS.BOOK_THANK_YOU_VIEWED);
  }, []);

  return (
    <ThankYouContainer ref={ref}>
      <BooKImage />

      <TyContainer>
        <ThankYouBookCard>
          <CardHeader>
            <CardTitle>Thank you!</CardTitle>
          </CardHeader>

          <CardHeader>
            <SectionHeading>We have your book!</SectionHeading>

            <TyCardDescription>
              Our Design Team will carefully review your stories, photos, and
              preferences to fully understand your project. Once our review is
              complete, we&apos;ll reach out with any questions and share the
              next steps.
            </TyCardDescription>

            <SectionHeading style={{ marginTop: "20px", display: "block" }}>
              What to look forward to
            </SectionHeading>

            <TyCardDescription>
              You&apos;ll receive a custom cover design and a professionally
              designed interior, followed by three full rounds of design and
              layout revisions. We&apos;ve found that three rounds provide the
              right amount of time to personalize your book and make sure it
              feels just right before printing.{" "}
              <FormLink
                as="a"
                href="https://mystoriesmatter-prod-public-media.s3.us-east-1.amazonaws.com/book-order/Memoir+Process+Overview_Updated+May+2026.pdf"
                target="_blank"
              >
                See an overview of our general timeline for working on your book
                here
              </FormLink>
            </TyCardDescription>

            <TyCardDescription>
              If you have questions, please contact{" "}
              <FormLink as="a" href="mailto:bookdesign@mystoriesmatter.com">
                bookdesign@mystoriesmatter.com
              </FormLink>
            </TyCardDescription>
          </CardHeader>

          <TyCardFooter>
            <TyCardButton to="/memories" type="secondary">
              <TbArrowLeft /> Back to my chapters
            </TyCardButton>
          </TyCardFooter>
        </ThankYouBookCard>

        <TyFooter>
          <TyFooterText>
            {"Have a question?"}
            <TyFooterLink
              as="a"
              href="https://www.mystoriesmatter.com/support?no-redirect=true"
              target="_blank"
            >
              {"Contact us!"}
            </TyFooterLink>
          </TyFooterText>
        </TyFooter>
      </TyContainer>
    </ThankYouContainer>
  );
};

export default React.forwardRef(ThankYouComponent);
